import React, { Component } from "react";
import { Card, CardBody, Col, Row } from 'reactstrap';
import { metadataService } from '../../_services';

class Banner extends Component {
    render() {
        var bannerClass = this.props.type !== undefined ? "banner-type-" + this.props.type : "banner-type-0";

        return (
            <Row className="justify-content-center">
                <Col>
                    <Card className="mb-3 ml-3 mr-3">
                        <CardBody>
                            <div className='text-centered'>
                                <div className={ "banner-card " + bannerClass}>
                                    <p>
                                        {metadataService.getParsedBannerText(this.props.text)}
                                    </p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }
}

export { Banner };
